/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {NotificationDisconnectIcon} from '../icons/NotificationDisconnectIcon';
import UserNotificationDialog from './UserNotificationDialog';

// defines the prop definitions for the session timeout ...
export type SessionTimeoutProps = {
  show: boolean;
  onLogin: () => void;
};

/**
 * The SessionTimeout component provides a Dialog Notification defined by the DLS
 * which is to be displayed to the user when their session has expired.
 *
 * This component requires applications to define an "notifications.json"
 * translation document with the following keys:
 *
 *   - notifications:session.title
 *   - notifications:session.message
 *   - notifications:session.login
 *
 * @see https://www.figma.com/file/z9yUzIaskZRhgpYIhLyh91/03_Hero-Screens?node-id=632%3A82003
 *
 * ```typescript
 *   import {SessionTimeout} from '@ion/dls/src/notifications/SessionTimeout';
 *
 *   const SessionTimeoutNotification = () => {
 *     <SessionTimeout ... />
 *   }
 *
 * ```
 *
 */
export const SessionTimeout = ({show, onLogin}: SessionTimeoutProps) => {
  return (
    <UserNotificationDialog show={show}
      icon={<NotificationDisconnectIcon />}
      title={translate('notifications:session.title')}
      message={translate('notifications:session.message')}
      actionLabel={translate('notifications:session.login')}
      onAction={onLogin}
      capitalize />
  );
};
export default SessionTimeout;
